import { MediaEntityType } from '@ancon/wildcat-types'

import getMediaImageCdnUrl from '../../app/utils/getMediaImageCdnUrl'

type Outlet = {
  id: string
  logoId: string | null
  tenantId: string
}

export default function getOutletLogoImageUrl<T extends Outlet>(
  outlet: T | null,
) {
  if (outlet?.logoId) {
    return getMediaImageCdnUrl(
      outlet.tenantId,
      outlet.logoId,
      MediaEntityType.Outlet,
      outlet.id,
    )
  }

  return null
}
